import { render } from "./contacts.vue?vue&type=template&id=3e302ad8&scoped=true"
import script from "./contacts.vue?vue&type=script&lang=js"
export * from "./contacts.vue?vue&type=script&lang=js"

import "./contacts.vue?vue&type=style&index=0&id=3e302ad8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e302ad8"]])

export default __exports__